<template>
  <gmap-map
    ref="map"
    :center="center"
    :zoom="13"
  >
    <gmap-marker
      :position="center"
    ></gmap-marker>
  </gmap-map>
</template>

<script>
import StoreMarker from './store-marker'
import { mapGetters } from 'vuex'

export default {
  components: {
    'store-marker': StoreMarker,
  },
  data: function() {
    return {
      map: null,
    }
  },
  computed: {
    ...mapGetters([
      'store',
    ]),
    center () {
      return {
        lat: this.latitude,
        lng: this.longitude,
      }
    },
    latitude () {
      return parseFloat(this.store.store_latitude)
    },
    longitude () {
      return parseFloat(this.store.store_longitude)
    },
  },
}
</script>
